import React, { useState, useEffect } from 'react';
import { Badge } from 'antd';
import { useRightPanel } from '../../contexts/RightPanelContext';
import { useEmbeddedAuth } from '../../contexts/EmbeddedAuthContext';
import notificationService from '../../services/notificationService';
import { getToken } from '../../services/authService';
import notificationIcon from '../../assets/icons/NotificationIcon.svg';
import publishButtonDefault from '../../assets/icons/PublishButton_Default.svg';
import publishButtonHover from '../../assets/icons/PublishButton_Hover.svg';
import publishButtonActive from '../../assets/icons/PublishButton_Active.svg';

const PublishButton = ({ label, active, hovered, onClick, onMouseEnter, onMouseLeave }) => {
  let bgSrc = publishButtonDefault;
  if (active) {
    bgSrc = publishButtonActive;
  } else if (hovered) {
    bgSrc = publishButtonHover;
  }

  return (
    <div
      className="relative w-[142px] h-[34px] cursor-pointer select-none"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <img
        src={bgSrc}
        alt="Publish Button Background"
        className="absolute inset-0 w-full h-full pointer-events-none"
      />
      <span
        className="absolute text-[13px] font-medium text-[#05042E]"
        style={{
          fontFamily: 'Arial, sans-serif',
          left: '90px',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          marginTop: '2px', // Fine-tuning to match original SVG baseline visual
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </span>
    </div>
  );
};

const PanelControlButtons = () => {
  const { activePanel, togglePanel } = useRightPanel();
  const { showLoginModal } = useEmbeddedAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isPublishHovered, setIsPublishHovered] = useState(false);

  const ensureAuthenticated = () => {
    if (getToken()) return true;
    showLoginModal();
    return false;
  };

  useEffect(() => {
    const fetchUnreadCount = async () => {
      try {
        if (!getToken()) return;
        const count = await notificationService.getUnreadCount();
        setUnreadCount(count || 0);
      } catch (error) {
        console.error('Failed to fetch unread count:', error);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center gap-3">
      {/* Publish Button */}
      <PublishButton
        label="发布新内容"
        active={activePanel === 'publish'}
        hovered={isPublishHovered}
        onClick={() => {
          if (!ensureAuthenticated()) return;
          togglePanel('publish');
        }}
        onMouseEnter={() => setIsPublishHovered(true)}
        onMouseLeave={() => setIsPublishHovered(false)}
      />

      {/* Notification Button */}
      <div
        className="cursor-pointer select-none relative"
        onClick={() => {
          if (!ensureAuthenticated()) return;
          togglePanel('notification');
        }}
      >
        <Badge dot={unreadCount > 0} offset={[-2, 2]}>
          <img src={notificationIcon} alt="Notification" className="block w-8 h-8" />
        </Badge>
      </div>
    </div>
  );
};

export default PanelControlButtons;
